import {
  ITEM_CARD_NARRATIVE_LIST_VIEW,
  ITEM_CARD_SEQUENCE_LIST_VIEW,
  NARRATIVE_VIEW,
  TIMELINE_VIEW
} from "./identifiers";

const MOBILE_PORTRAIT_VIEW_TYPES = [ITEM_CARD_SEQUENCE_LIST_VIEW, ITEM_CARD_NARRATIVE_LIST_VIEW];

const MOBILE_LANDSCAPE_VIEW_TYPES = [TIMELINE_VIEW, NARRATIVE_VIEW];

export { MOBILE_LANDSCAPE_VIEW_TYPES, MOBILE_PORTRAIT_VIEW_TYPES };
